import DelegationAddParams, {
  DelegationAddParamsAddress,
} from "../../../../../common/services/delegation/add/delegation-add-params";
import VehicleType from "../../../../../common/types/vehicle-type";
import DelegationAddFormData from "../form/types/delegation-add-form-data";
import DelegationAddAddress from "../types/delegation-add-address";
import DelegationAddVehicleType from "../types/delegation-add-vehicle-type";

const createVehicleType = (type: DelegationAddVehicleType): VehicleType => {
  switch (type) {
    case DelegationAddVehicleType.CAR_GT_900CM3:
      return VehicleType.CAR_GT_900CM3;
    case DelegationAddVehicleType.CAR_LE_900CM3:
      return VehicleType.CAR_LE_900CM3;
    case DelegationAddVehicleType.COMPANY_OWNED:
      return VehicleType.COMPANY_OWNED;
    case DelegationAddVehicleType.MOPED:
      return VehicleType.MOPED;
    case DelegationAddVehicleType.MOTORCYCLE:
      return VehicleType.MOTORCYCLE;
  }
};

const createVehicleTypes = (
  types: DelegationAddVehicleType[],
): VehicleType[] => {
  return types.map(createVehicleType);
};

const createAddress = (
  address: DelegationAddAddress,
): DelegationAddParamsAddress => {
  return {
    displayName: address.displayName,
    latitude: address.latitude,
    longitude: address.longitude,
    apartmentNumber: address.apartmentNumber,
    distance: address.distance,
    houseNumber: address.houseNumber,
    street: address.street,
    time: address.time,
    town: address.town,
    zipCode: address.zipCode,
  };
};

const createAddressSequence = (
  addresses: DelegationAddAddress[][],
): DelegationAddParamsAddress[][] => {
  return addresses.map((group) => group.map(createAddress));
};

const create = (
  formData: DelegationAddFormData,
  groupVehicleTypes: DelegationAddVehicleType[],
): DelegationAddParams => {
  return {
    workerCompanyUuid: formData.workerCompanyUuid,
    workerUuid: formData.workerUuid,
    dateFrom: formData.dateFrom!,
    dateTo: formData.dateTo!,
    mileagesCost: formData.mileagesCost!,
    totalDistance: formData.totalDistance!,
    addressSequence: createAddressSequence(formData.addressSequence),
    osrmDistance: formData.osrmDistance ?? formData.totalDistance!,
    accommodationBillsCost: formData.accommodationBillsCost ?? undefined,
    accommodationCost: formData.accommodationCost ?? undefined,
    prepay: formData.prepay ?? undefined,
    startedDayDietCost: formData.startedDayDietCost ?? undefined,
    wholeDayDietCost: formData.wholeDayDietCost ?? undefined,
    localTravelCost: formData.localTravelCost ?? undefined,
    oneDayDietCost: formData.oneDayDietCost ?? undefined,
    otherExpenses: formData.otherExpenses ?? undefined,
    groupVehicleTypes: createVehicleTypes(groupVehicleTypes),
  };
};

const delegationAddParamsFactory = {
  create,
};

export default delegationAddParamsFactory;
